module.exports = __webpack_public_path__ + "static/media/RD_Sviadnov.c2e8404b.jpg";